import { Loader } from 'packages/eid-ui'
import {
    MenuItem,
    Typography,
    ListItemIcon,
    Paper,
    useTheme,
} from '@mui/material'
import { useHistory } from 'react-router'
import { useQuery } from 'packages/core'
import { Icon } from 'packages/eid-icons'
import { useUiActionsByResource } from 'hooks'
import { useTranslation } from 'react-i18next'
import { handleRenderWorkflow } from 'utils'

const ActionsList = ({ workflows, resourceId, route }) => {
    const { t } = useTranslation()
    const query = useQuery()
    const history = useHistory()
    const theme = useTheme()
    const handleClick = (name) => {
        handleRenderWorkflow(
            [`SelectedResourceGuid=${resourceId}`],
            name,
            history,
        )
    }

    return (
        <>
            {workflows && workflows.length > 0 ? (
                workflows.map((d, i) => (
                    <MenuItem
                        tabIndex={0}
                        role="button"
                        aria-label={d.friendlyName}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault()
                                handleClick(d.requestWorkflowName)
                            }
                        }}
                        onClick={() => handleClick(d.requestWorkflowName)}
                        sx={{
                            fontSize: '14px',
                            color: theme?.palette?.primary?.main,
                            position: 'relative',
                            minHeight: '40px !important',
                            borderLeft: '2px solid transparent',
                            whiteSpace: 'normal',
                            '&:hover': {
                                backgroundColor: `${theme?.palette?.primary?.light} !important`,
                                borderLeft: `2px solid ${theme?.palette?.primary?.main}`,
                                '& svg': {
                                    opacity: 1,
                                    filter: 'grayscale(0%) ',
                                    color: 'blue',
                                },
                            },
                        }}
                        key={i}
                    >
                        <ListItemIcon
                            sx={{
                                minWidth: '20px',
                                color: '#aab0b4',
                                '& svg': {
                                    height: '16px',
                                    width: '16px',
                                },
                            }}
                        >
                            <Icon
                                name="Arrow"
                                direction="right"
                                color="#aab0b4"
                            />
                        </ListItemIcon>
                        {d.friendlyName}
                    </MenuItem>
                ))
            ) : (
                <Typography
                    sx={{
                        minWidth: '40px',
                        fontSize: '14px',
                        padding: '10px',
                    }}
                >
                    {t('NoActionFound')}
                </Typography>
            )}
        </>
    )
}

const WorkflowActions = ({ resource, route }) => {
    const { data, isInitialLoading } = useUiActionsByResource(resource.id)
    return (
        <>
            {isInitialLoading ? (
                <Loader />
            ) : (
                <Paper
                    style={{
                        borderRadius: '5px',
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <ActionsList
                        workflows={data}
                        resourceId={resource.id}
                        route={route}
                    />
                </Paper>
            )}
        </>
    )
}

export default WorkflowActions
